<template>
  <span class="z-tooltip z-icon z-icon--medium z-icon--primary">
    <z-icon
      :icon="['far', 'question-circle']"
      :title="tooltip"
      size="medium"
    />
    <span class="z-tooltip__box z-tooltip__box--top-right tooltip-box-override">
      {{ tooltip }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
.tooltip-box-override {
  text-transform: initial;
}
</style>

<script>
export default {
  props: {
    tooltip: {
      type: String,
      default: undefined,
    },
  },
};
</script>
